import { WartungsfensterListItem } from 'app/core/services/api-client';

export interface IStartPageInfoState {
  systemMessageHtml: string;
  wartungsfenster: WartungsfensterListItem[];
}

export const initialState: IStartPageInfoState = {
  systemMessageHtml: null,
  wartungsfenster: [],
};
